import ROUTE from '@app/navigationApp/routes';
import { useAppSelector } from '@app/store/hooks';
import { RootState } from '@app/store/newstore';
import { parseParameters } from '@app/utils/utils';
import { useEffect } from 'react';
import {View, ActivityIndicator,Platform} from 'react-native';
import VoltLogoNew from '../../../assets/Icons/VoltLogoNew';
import { phonePayRoutes } from '@voltmoney/micro-frontend/lib/configs/utils';

const Loader = ({navigation}) => {
    const userDetails = useAppSelector((state: RootState) => state.auth?.userDetails);
    const platformParams = useAppSelector((state: RootState) => state.platformParams);
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail===null;

    const {showHome,plj,plk,platform,isFromPhonePe,isFromBajaj} = platformParams
    useEffect(() => {
        if(Platform.OS === 'web' && platformParams?.isParamsUpdated &&userDetails!==null){
            const skipToEnterEmail = ['JUPITER','BHARAT_PE','PARKPLUS','TATADIGITAL','BHARAT_PE_2','PARKPLUS','PHONEPE','SDK_INVESTWELL','LARK'].includes(platform);

            const isFromBharatPe = platform==='BHARAT_PE';
            const isFromSecondBharatPe = platform==='BHARAT_PE_2';
        setTimeout(() => {
            if(!showHome){
                if(userEmailNotExist){
                    navigation.navigate(Boolean(plj) || skipToEnterEmail ? ROUTE.ENTER_EMAIL :ROUTE.VERIFY_EMAIL);
                }
                else if(currentStepName){
                    if(isFromPhonePe || isFromSecondBharatPe || isFromBharatPe){
                        if(phonePayRoutes.includes(currentStepName)){
                            navigation.navigate(currentStepName);
                        }
                        else{
                            navigation.navigate('SPLASH_SCREEN');
                        }
                    }
                    else{
                        navigation.navigate(currentStepName);
                    }
                }
                else{
                    navigation.navigate('SPLASH_SCREEN');
                }   
            }
            else {
                if(Boolean(plk) && userEmailNotExist){
                    navigation.reset({
                        routes: [{ name: ROUTE.HOME }, { name: ROUTE.ENTER_EMAIL }],
                      });
                }
                else{
                    navigation.navigate(ROUTE.HOME);
                }
            }

        }, 300);
      }
      }, [platformParams?.isParamsUpdated]);
    return (
    <View style={{ backgroundColor: 'white', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {/* <VoltLogoNew/> */}
        <ActivityIndicator size={12} color="#1434CB" />
    </View>
  );
}
export default Loader;